/**
 * Adds a soft fade-in to lazy-loaded images once they've actually finished
 * downloading, instead of the abrupt "pop" a browser paints them with by
 * default. Watches the whole page via MutationObserver so it also covers
 * images injected later (collection "load more", quick add, predictive
 * search, filtered results, etc.) without each of those features needing to
 * know about this behaviour.
 */
(function () {
  function registerLazyImage(img) {
    if (img.classList.contains('is-loaded') || img.dataset.lazyFadeBound) return;
    img.dataset.lazyFadeBound = 'true';

    if (img.complete) {
      img.classList.add('is-loaded');
    } else {
      img.addEventListener('load', () => img.classList.add('is-loaded'), { once: true });
      img.addEventListener('error', () => img.classList.add('is-loaded'), { once: true });
    }
  }

  function registerLazyImagesIn(node) {
    if (!node || node.nodeType !== Node.ELEMENT_NODE) return;
    if (node.matches('img[loading="lazy"]')) registerLazyImage(node);
    node.querySelectorAll?.('img[loading="lazy"]').forEach(registerLazyImage);
  }

  document.addEventListener('DOMContentLoaded', () => registerLazyImagesIn(document.body));

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach(registerLazyImagesIn);
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
